module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-4-Audio-3.01e40978.mp3";